import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { PartnerCampaignService } from "../services/partner-campaign.service";
import { AuthService } from "@core/services/auth.service";

export const partnerCampaignCollateralResolver: ResolveFn<void> = async () => {
  const partnerCampaignService = inject(PartnerCampaignService);  // PartnerCampaignService
  const authService = inject(AuthService);  // AuthService

  if (!authService.isYcAdminOrSupport()) {
    await partnerCampaignService.getPartnerCampaignCollateral();
  }
}